import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  type?: string;
  ogImage?: string;
  keywords?: string;
  path?: string;
}

export default function SEOHead({ title, description, canonical, type = "website", ogImage, keywords, path }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", type, "property");
    setMeta("twitter:title", title, "name");
    setMeta("twitter:description", description, "name");

    if (keywords) {
      setMeta("keywords", keywords);
    }

    if (ogImage) {
      const fullUrl = ogImage.startsWith("http") ? ogImage : `${window.location.origin}${ogImage}`;
      setMeta("og:image", fullUrl, "property");
      setMeta("twitter:image", fullUrl, "name");
    }

    const resolvedCanonical = canonical || (path ? `https://simonleeandassociates.com${path}` : undefined);
    if (resolvedCanonical) {
      setMeta("og:url", resolvedCanonical, "property");
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = resolvedCanonical;
    }

    return () => {
      const link = document.querySelector('link[rel="canonical"]');
      if (link) link.remove();
    };
  }, [title, description, canonical, type, ogImage, keywords, path]);

  return null;
}
